
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "Play",
        "possibleTypes": [
          {
            "name": "ActivePlay"
          },
          {
            "name": "PendingPlay"
          },
          {
            "name": "FinishedPlay"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Prompt",
        "possibleTypes": [
          {
            "name": "ActivePrompt"
          },
          {
            "name": "PendingPrompt"
          }
        ]
      }
    ]
  }
};
      export default result;
    